import { SERVICE_RESPONSE } from './Const';
import { ApiClient } from '../apiClient';

// Esta rama solo admite idSession. Al incorporar el backend que acepta DocEntry,
// habilitar esta capacidad permitirá usar el mismo flujo desde el modal de facturas.
export const supportsInvoiceReprocessing = true;

const apiClient = ApiClient.getInstance();

export const processPendingPayment = async (type, item) => {
    let body;
    let requestedDocEntry;

    switch (type) {
        case 'SESSION':
            body = { idSession: Number(item.idSession) };
            if (!Number.isSafeInteger(body.idSession) || body.idSession <= 0) {
                throw new Error('La sesión seleccionada no es válida.');
            }
            break;
        case 'INVOICE':
            if (!supportsInvoiceReprocessing) {
                throw new Error('El reproceso individual de facturas aún no está disponible.');
            }
            requestedDocEntry = Number(item.DocEntry);
            if (!Number.isSafeInteger(requestedDocEntry) || requestedDocEntry <= 0) {
                throw new Error('La factura seleccionada no es válida.');
            }
            body = { DocEntry: requestedDocEntry };
            break;
        default:
            throw new Error('Tipo de reproceso no soportado.');
    }

    const response = await apiClient.processPayments(body);
    const data = response?.data || {};
    const successPayments = Array.isArray(data.successPayments) ? data.successPayments : [];
    const errorsPays = Array.isArray(data.errorsPays) ? data.errorsPays : [];
    const confirmedPayments = type === 'INVOICE'
        ? successPayments.filter((entry) => Number(entry) === requestedDocEntry)
        : successPayments;
    const processed = response?.status === SERVICE_RESPONSE.SUCCESS
        && confirmedPayments.length > 0 && errorsPays.length === 0;

    return {
        processed,
        successPayments: confirmedPayments,
        errorsPays,
        message: response?.message || 'No se confirmó el reproceso del pago.',
    };
};
